// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/wave.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/zebra.avif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/map12.avif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/banner1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/wave_footer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 기본 리셋 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Roboto;
  line-height: 1.6;
  padding-top: 110px;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 0rem;
}
.home-container {
  margin-top: -10px;
}

.container-full {
  max-width: 1280px;
  max-width: 100%;
  margin: 0 auto;
}

section {
  margin-bottom: 5rem;
}

header {
  position: fixed;
  top: 40px;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  height: 60px;
  color: #000;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 50px;
  height: 100%;
}
.logo {
  flex: 0 0 auto;
}

.logo a {
  color: #004d00;
  text-decoration: none;
  font-family: Anton;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.logo-text {
  color: #004d00;
  font-family: Anton;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.logo-image {
  height: 40px;
  width: auto;
  margin-right: 5px;
}
.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
}

.nav-links li {
  margin: 0;
}

.nav-links li a {
  color: #004d00;
  font-weight: 600;
  text-decoration: none;
  font-size: 1rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  padding: 0.7rem 1.2rem;
}
.nav-links li a:hover {
  color: #e8c140;
}

.nav-links li.btn-yellow a,
.nav-links li.btn-green a {
  color: #fff !important;
}

/* 네비게이션 바 버튼 스타일링 */
.nav-links li a.plan-trip,
.nav-links li a.contact-us {
  padding: 0.5rem 1rem;
  /* border-radius: 5px; */
}

.nav-links li a.plan-trip {
  background: #ff9800;
  color: #fff;
}
.nav-links li a.contact-us {
  background: #004d00;
  color: #fff;
}

.btn-yellow {
  background: #e8c140;
  padding: 0.5rem 0.5rem;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}

.btn-yellow a {
  color: black !important;
}

.btn-green {
  background: #004d00;
  padding: 0.5rem 0.5rem;
  border-radius: 10px;
}

.btn-green a {
  color: #fff !important;
}
/* TopBar styles */
.top-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 1002;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.top-bar-container {
  max-width: 1280px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
}

.top-bar-left {
  display: flex;
  gap: 15px;
  align-items: center;
}

.top-bar-right {
  display: flex;
  gap: 20px;
}

.top-bar-icon {
  margin-right: 8px;
  font-size: 0.8rem;
  color: #004d00;
}

.top-bar-social-icon {
  font-size: 15px;
  color: #004d00;
  transition: color 0.3s ease;
}
.top-bar-social-icon:hover {
  color: #e8c140;
}

.top-bar-left span {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  color: #004d00;
  margin-right: 15px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
}

/* Dropdown styles */
.dropdown {
  position: relative;
}

.dropdown-content {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  min-width: 220px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 0.8rem 0;
  transition: all 0.3s ease;
  margin-top: 10px;
}

/* Arrow for dropdown */
.dropdown-content::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
}

/* Show dropdown on hover */
.dropdown:hover .dropdown-content {
  visibility: visible;
  opacity: 1;
  margin-top: 0;
}
.dropdown-content a,
.dropdown-content .a {
  color: #004d00 !important;
  padding: 0.8rem 1rem !important;
  display: block;
  text-decoration: none;
  font-size: 0.9rem !important;
  transition: all 0.3s ease;
  text-align: left;
  cursor: pointer;
}

.dropdown-content a:hover,
.dropdown-content .a:hover {
  background-color: #f8f9fa;
  color: #e8c140 !important;
  padding-left: 2rem !important;
}

/* hero section */
#hero {
  position: relative;
  height: 85vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  margin-bottom: 0;
  margin: 0 0 0;
  z-index: 0;
}

.hero-slideshow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transform: scale(1.1);
  transition: opacity 2s ease, transform 2s ease;
}

.slide.active {
  opacity: 1;
  transform: scale(1);
}

.slide::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

#hero .overlay {
  font-family: Poppins, sans-serif;
  /* font-family: Picsart-Fonts, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Helvetica, Arabic, sans-serif; */
  position: relative;
  padding: 2rem;
  border-radius: 10px;
  color: white;
  max-width: 130vh;
  margin: 0 auto;
  padding-top: 60px;
}
#hero .overlay button {
  margin: 0 auto;
  background-color: transparent;
  border: 2px solid white;
  display: block;
  animation: fadeInUp 1s ease-out 0.6s;
  opacity: 1;
  border-radius: 10px;
  animation-fill-mode: forwards;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  color: white;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

#hero h1 {
  font-family: "Regular Blush", cursive !important;
  font-weight: 400;
  font-size: 5rem;
  animation: fadeInUp 1s ease-out;
}

#hero p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2;
  margin-bottom: 1.5rem;
  animation: fadeInUp 1s ease-out 0.3s;
  opacity: 1;
  animation-fill-mode: forwards;
}
#hero .overlay a {
  text-decoration: none !important;
  color: inherit;
}
#hero .overlay a:hover {
  text-decoration: none !important;
}
#hero .overlay a:visited {
  color: inherit;
  text-decoration: none !important;
}

.whatsapp-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25d366;
  color: white;
  width: auto;
  padding: 10px 20px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  transition: all 0.3s ease;
}

.whatsapp-icon svg {
  font-size: 1.4rem;
}

.whatsapp-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.4);
}

.logo-image {
  max-height: 120px;
  width: auto;
  object-fit: contain;
}
.wave {
  position: relative;
  height: 30px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center bottom;
  background-size: cover;
  margin-top: -30px;
  /* 이미지가 겹치도록 설정 */
}

/* Section: Why Choose Us */
.why-choose-us {
  padding: 0px 0;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  padding-bottom: 2rem;
}
.why-choose-us::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.972); /* Simple white overlay */
}

.why-choose-us h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  padding: 0rem 1rem;
  font-size: 2.5rem;
  margin-top: 3rem;
  text-align: center;
  margin-bottom: 3.5rem;
  position: relative;
  color: black;
  z-index: 2;
}

.why-choose-us h2:after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 120px;
  position: relative;
  z-index: 2;
}

.feature-card {
  text-align: center;
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  background-color: #004d00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #fff;
  font-size: 24px;
}

.feature-card h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.feature-card p {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
}

/* PopularTours.js */
.popular-tours-section {
  padding: 0rem 0rem;
  margin-bottom: 2rem;
}

.popular-tours-title {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  padding: 0rem 1rem;
  margin-top: 3rem;
  text-align: center;
}

.popular-tours-title h2 {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
}

.popular-tours-title h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}

.p-tour-destination {
  font-size: 0.9rem;
  background-color: #004d00a4;
  color: white;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 0.2rem 0.6rem;
  border-radius: 5px;
  font-weight: 500;
}
.p-tour-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.p-tour-link {
  text-decoration: none;
  color: inherit;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 1rem);
  box-sizing: border-box;
}
.p-tour-link:nth-child(n + 5) {
  display: none;
}

.p-tour-card {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.p-tour-image {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.p-tour-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s ease;
}

.p-tour-card:hover .p-tour-image img {
  transform: scale(1.1);
}

.p-tour-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  padding: 0.8rem;
}

.p-tour-days {
  font-size: 0.9rem;
  color: #333;
}
.p-tour-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.p-tour-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}
.p-tour-info {
  padding: 0 1rem;
  height: 180px;
  overflow-y: auto;
}
.p-tour-location {
  font-size: 0.8rem;
  color: #555;
}
.p-tour-price-text {
  font-size: 0.9rem;
  color: #555;
}
.p-tour-price span {
  font-size: 0.9rem;
  color: #555;
  font-weight: 500;
}
.p-tour-price {
  font-size: 1 rem;
  color: #004d00a4;
  font-weight: 600;
  font-family: Poppins, sans-serif;
}
.p-tour-title {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0.5rem 0.5rem;
  height: 60px;
  text-transform: uppercase;
}

.p-tour-days {
  font-size: 0.9rem;
  color: #333;
}
.view-details-button {
  background: transparent;
  background-color: #004d00a4;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  border-radius: 5px;
  border: none;
}

/* Section: Destinations */
.destinations {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  background-size: cover;
  color: black;
  width: 100%;
  padding: 2rem 0;
  border-radius: 1rem;
  position: relative;
}

.destinations::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(252, 249, 242, 0.99);
}

/* Make sure content appears above the overlay */
.destinations h2,
#destinations {
  position: relative;
  z-index: 2;
}

#destinations {
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 1rem;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(25% - 1.5rem), 1fr));
  gap: 2rem;
  justify-content: space-between;
}
.destinations h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  position: relative;
}
.destinations h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}

.card {
  position: relative;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  /* aspect-ratio: 1 / 1.3; */
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6); /* Adjust the color and opacity as needed */
  opacity: 0;
  transition: opacity 0.4s ease;
}

.card:hover::before {
  opacity: 1;
}

.card-title {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  z-index: 2;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.card:hover .card-title {
  transform: translate(-50%, -50%);
  top: 50%;
  opacity: 1;
}

.card-title span {
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.3rem;
}

/* Section: Activities */
.section.activities {
  padding: 0rem 2rem;
}
.activities-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.activities-header h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  padding: 0rem 1rem;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  text-align: center;
}

.activities-header h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}
/* View All Button Styles */
.view-all-button,
.view-all-activities,
.articles-view-all-button {
  align-items: center;
  display: block;
  margin: 2rem auto 0;
  padding: 8px 30px;
  background-color: transparent;
  border: 2px solid #e8c140;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  text-align: center;
  color: #666 !important;
}

.view-all-button:hover,
.view-all-activities:hover,
.articles-view-all-button:hover {
  background-color: #e8c140;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(232, 193, 64, 0.3);
}

/* Container styles for view all buttons */
.view-all-container,
.articles-view-all-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.list-container {
  padding: 0rem 1rem;
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: 0.6fr 1fr 0.8fr 0.8fr;
  grid-template-rows: auto auto;
  grid-template-rows: repeat(2, 220px);
  gap: 20px;
}

.list {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}
.list img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}
.list-title {
  font-family: Poppins, sans-serif;
  color: white;
  font-size: 1.2rem;
  padding: 10px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-weight: 700;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
  transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease;
  z-index: 2;
  background-color: transparent;
}

.list:hover .list-title {
  bottom: 50%;
  transform: translate(-50%, 50%);
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
}

/* Assign grid positions */
.list:nth-child(1) {
  grid-column: 1;
}

.list:nth-child(2) {
  grid-column: 2;
  grid-row: 1 / span 2;
}

.list:nth-child(3) {
  grid-column: 3 / span 2;
  grid-row: 1;
}

.list:nth-child(4) {
  grid-column: 1;
  grid-row: 2;
}

.list:nth-child(5) {
  grid-column: 3;
  grid-row: 2;
}

.list:nth-child(6) {
  grid-column: 4;
  grid-row: 2;
}

.modal {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 80%;
  max-height: 80%;
  overflow-y: auto;
  position: relative;
  border-radius: 10px;
}

.close-icon {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  transition: color 0.3s;
}

.close-icon:hover {
  color: #e8c140;
}

.modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 40px;
}

.modal-list {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.modal-list img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

.activities-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Section: Banner */
.banner {
  font-family: "Lato", sans-serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 400px;
  margin: 60px auto;
  padding: 20px;
  background: linear-gradient(to right, #eedbb733, #efca85dd);
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}
.banner .text-section {
  text-align: center;
}
.banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: cover;
  filter: brightness(0.7);
  z-index: 1;
}

.text-section {
  position: relative;
  z-index: 2;
  max-width: 50%;
  padding: 20px;
}

.text-section h2 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #333;
}

.text-section p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 20px;
  color: #555;
}

.book-now {
  background-color: white;
  border: 2px solid #e8c140;
  color: #e8c140;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.book-now:hover {
  background-color: #d1a837;
  transform: scale(1.05);
}

.icon {
  margin-right: 8px;
  color: #e8c140;
}

/* Section: Partners */
.partners {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow-x: auto;
  padding: 2rem 1rem;
}
#ourpartners h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-size: 2.5rem;
  position: relative;
  margin: 2rem auto;
}
#ourpartners h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}

/* Section: Articles */
.articles-section {
  text-align: left;
  padding: 2rem 0;
}

.articles-section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
  text-align: center;
}

.articles-section-title h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-size: 2.5rem;
  position: relative;
  margin: 0 auto;
}

.articles-section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}
.articles-view-all-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.articles-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 2rem;
}

.article-card {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: calc(33.33% - 1rem);
  margin-bottom: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.article-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.article-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.article-info {
  padding: 1rem;
  text-align: left;
}

.article-date {
  color: #777;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.article-title {
  font-size: 1.125rem;
  margin: 0.5rem 0;
  color: #333;
}
.article-excerpt {
  color: #777;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.read-more-button {
  display: inline-block;
  color: #e8c140;
  font-weight: bold;
  border: none;
  background-color: transparent;
  text-decoration: none;
  margin-top: 0.5rem;
  padding: 0.5rem 0.5rem;
  border-radius: 10px;
}

.read-more-button:hover {
  text-decoration: underline;
}

.articles-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
}
.subscribe-section {
  font-family: "Lato", sans-serif;
  background-color: #f8f9fa;
  padding: 2rem;
  text-align: center;
  margin-top: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.subscribe-section h3 {
  font-size: 1.5rem;
  font-weight: 500;
}
.subscribe-section p {
  font-size: 1rem;
  color: #777;
}
.subscribe-form {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.subscribe-form input {
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 250px;
}
.subscribe-form button {
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0.5rem 0.5rem;
  border-radius: 4px;
  background-color: #e8c140;
  border: none;
}
/* Reviews Section */

.reviews-header {
  position: relative;
  z-index: 2;
  text-align: center;
  margin-bottom: 3rem;
}

.reviews-header h2 {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  position: relative;
}

.reviews-header h2:after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #e8c140;
}

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 2;
}

.review-card {
  padding: 2rem;
  text-align: left;
  color: #000;
}

.stars {
  color: #e8c140;
  font-size: 1.35rem;
  margin-bottom: 1rem;
}
.rating-value {
  font-size: 1rem;
  color: #666;
  margin-left: 0.25rem;
}

.review-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #000;
  margin-bottom: 1rem;
  transition: max-height 0.3s ease-out;
  text-align: justify;
}
.review-author-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.review-author-info img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  object-position: top center;
  border-radius: 50%;
}
.review-author-info h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.review-author-info span {
  color: #666;
  font-size: 0.9rem;
}
.review-text.expanded {
  display: block;
  -webkit-line-clamp: unset;
  max-height: none;
}

.read-more-btn {
  display: none;
  color: #666;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.5rem;
  background: none;
  border: none;
  padding: 0;
}

/* Footer */
.footer {
  background-color: #004d00;
  color: white;
  padding: 1rem 0;
  margin-top: 2rem;
  font-size: 0.8rem;
}
.wave-footer {
  position: relative;
  height: 3rem;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center bottom;
  background-size: cover;
  margin-top: -1rem;
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-column {
  flex: 1 1;
  min-width: 200px;
  margin: 20px;
}

.footer-column h3 {
  margin-bottom: 20px;
}

#contact {
  flex: 3 1;
}

.footer-column p,
.footer-column ul,
.footer-column form {
  margin-bottom: 20px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column ul li {
  margin-bottom: 10px;
}

.footer-column ul li a {
  color: white;
  text-decoration: none;
}

.footer-column ul li a:hover {
  text-decoration: underline;
}

#newsletter {
  flex: 3 1;
}

#h3-follow {
  font-size: 1.5rem;
}

/* 뉴스레터 폼 스타일링 */
.newsletter-form {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  flex-direction: row;
  /* 한 줄로 배 */
}

.newsletter-form input[type="email"] {
  width: 10rem;
  border: none;
  padding: 10px;
  flex: 1 1;
  border-radius: 5px 0 0 5px;
  /* 왼쪽 모서리만 둥게 */
}

.newsletter-form input[type="email"]:focus {
  border: none;
}

#newsletter-submit {
  background-color: #fff;
  color: black;
  border: none;
  padding: 10px 20px;
  /* 좌우 패딩 추가 */
  cursor: pointer;
  border-radius: 0 5px 5px 0;
  /* 오른쪽 모서리만 둥글게 */
  font-size: 1rem;
}

.newsletter-form button:hover {
  text-decoration: underline;
  background-color: #fff;
}

.social-icons {
  display: flex;
  gap: 10px;
}

.social-icons a {
  display: inline-block;
}

.social-icons img {
  width: 24px;
  height: 24px;
}

.footer-bottom {
  text-align: center;
  padding: 20px 0;
  color: white;
}

/* 링크 색상 및 데코레이션 설정 */
.footer a {
  color: white;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: none;
  color: white;
}
.menuToggleBtn {
  background: none;
  border: none;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 25px;
  color: #004d00;
  padding: 0 10px;
  display: none;
}

/* 태블릿: max-width 1024px */
@media (max-width: 1024px) {
  .logo {
    margin-right: auto;
  }
  .nav-links {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 0.2rem;
    margin-left: auto;
  }
  nav {
    display: flex;
    justify-content: space-between;
  }
  .nav-links li a {
    padding: 0.5rem 0.5rem;
  }
  .features {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
  }
  .feature {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(30% - 0.25rem);
    max-width: calc(30% - 0.25rem);
    aspect-ratio: 1/1;
  }
  #why-choose-us {
    margin-left: 3rem;
    margin-right: 3rem;
    box-sizing: border-box;
    object-fit: cover;
  }

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 1rem;
  }
  /* articles */
  .articles-list {
    gap: 1rem;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .article-card {
    min-width: 260px;
    flex: 1 1;
  }
  .article-image {
    height: auto;
  }
  .article-card:nth-child(n + 4) {
    display: none;
  }
  .testimonials-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding: 0 1rem;
  }
  .top-bar {
    padding: 8px 15px;
  }

  .top-bar-left {
    gap: 10px;
  }

  .top-bar-left span {
    font-size: 0.8rem;
  }
  .features-grid {
    padding: 0 4rem;
  }
  .subscribe-section {
    flex-direction: column;
  }
  .subscribe-form input {
    display: flex;
    flex-direction: column;
  }

  .reviews-grid {
    grid-auto-rows: 1fr;
    padding: 0 1rem;
  }

  .reviews-header h2 {
    font-size: 2rem;
  }
}

@media (min-width: 800px) and (max-width: 1024px) {
  .top {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 0 1rem;
  }
  .top-bar {
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 10px;
  }

  .top-bar-left {
    flex-wrap: nowrap;
    gap: 8px;
  }

  .top-bar-right {
    gap: 15px;
  }

  .top-bar-left span {
    font-size: 0.75rem;
  }
  .top-bar-left span:first-of-type,
  .top-bar-icon:first-of-type {
    display: none;
  }
  .logo-text {
    font-size: 1.2rem;
  }
  .features-grid {
    padding: 0 2rem;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
  }

  .p-tour-list {
    padding: 1rem;
  }
  .p-tour-link {
    text-decoration: none;
    color: inherit;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 1rem);
    box-sizing: border-box;
  }
  .p-tour-link:nth-child(n + 4) {
    display: none;
  }
  .reviews-grid {
    padding: 0 1rem;
  }
  .review-card {
    padding: 0;
  }
  .articles-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    justify-content: center;
    padding: 1rem;
  }
  .article-card {
    min-width: 260px;
    flex: 1 1;
  }
}

/* 모바일: max-width 768px */
@media (max-width: 768px) {
  .destinations h2,
  .reviews-header h2,
  .section-header h2,
  .activities-header h2,
  .articles-section-title h2,
  .popular-tours-title h2,
  .why-choose-us h2 {
    font-size: 2rem;
  }
  .top {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 0 1rem;
  }
  .logo-image {
    max-height: 50px;
  }
  .container {
    width: 95%;
  }
  nav {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .logo {
    margin-right: auto;
  }
  .nav-links {
    position: absolute;
    top: 100%;
    right: 15px;
    gap: 0;
    padding: 1rem;
    background-color: #fff;
    flex-direction: column;
    width: 250px;
    z-index: 1003;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    border-radius: 0 0 10px 10px;
  }
  .nav-links li {
    margin: 0.5rem 0;
    width: 100%;
    text-align: left;
  }
  .nav-links li a {
    white-space: nowrap;
  }

  .menuToggleBtn {
    cursor: pointer;
    z-index: 1004;
  }
  .menuToggleBtn {
    display: block;
  }
  .nav-links {
    display: none;
  }
  .nav-links.open {
    display: flex;
  }

  #hero h1 {
    font-size: 3rem;
  }
  #hero p {
    font-size: 1rem;
  }
  .features {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1rem;
  }
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 0 2rem;
  }
  .feature-card:nth-child(n + 4) {
    display: none;
  }
  .feature p {
    font-size: 0.8rem;
    white-space: wrap;
  }
  #why-choose-us {
    margin-left: 3rem;
    margin-right: 3rem;
    box-sizing: border-box;
    object-fit: cover;
  }
  .p-tour-link {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 1rem);
  }
  .p-tour-link:nth-child(n + 4) {
    display: none;
  }
  .p-tour-image {
    height: 150px;
  }
  .p-tour-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .p-tour-link {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.33% - 1rem);
    max-width: calc(33.33% - 1rem);
  }

  .p-tour-link:nth-child(n + 4) {
    display: none;
  }

  .p-tour-card {
    height: 100%;
  }

  .p-tour-image {
    height: 180px;
  }

  .p-tour-info {
    padding: 0.5rem;
    height: auto;
  }

  .p-tour-title {
    font-size: 0.9rem;
    height: auto;
    margin-bottom: 0.5rem;
  }

  .p-tour-price-text,
  .p-tour-price span {
    font-size: 0.8rem;
  }
  .p-tour-price {
    font-size: 0.9rem;
  }
  .view-details-button {
    font-size: 0.8rem;
  }

  #destinations {
    gap: 0.5rem;
    padding: 0.5rem;
    margin-top: 0.5rem;
  }
  .card-title {
    padding: 0.5rem;
    font-size: 1rem;
    bottom: 1rem;
    border-radius: 10px;
  }
  .card-title span {
    font-size: 0.7rem;
    margin: 0;
  }
  .card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .article-card {
    min-width: 210px;
  }
  .article-image {
    height: auto;
  }
  .article-card:nth-child(n + 4) {
    display: none;
  }
  .articles-list {
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow-x: auto;
    gap: 1;
    display: flex;
  }

  /* Section: Banner */
  .text-section {
    padding: 1rem;
  }
  .text-section h2 {
    font-size: 1.5em;
  }
  .text-section p {
    font-size: 1em;
  }
  .book-now {
    font-size: 1em;
    padding: 8px 16px;
  }
  .image-container {
    height: auto;
  }
  .image-section img {
    border-radius: 0;
  }
  .reviews-section {
    padding: 4rem 1rem;
  }
  .review-text {
    font-size: 0.9rem;
    margin-bottom: 1rem;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
  }
  .reviews-grid {
    gap: 0;
    padding: 0;
  }
  .testimonials-container {
    grid-template-columns: 1fr;
  }

  .testimonial-card {
    padding: 2rem;
  }

  .quote-icon {
    font-size: 1.5rem;
    top: 1.5rem;
    right: 1.5rem;
  }
  .top-bar {
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 10px;
  }

  .top-bar-left {
    flex-wrap: nowrap;
    gap: 8px;
  }

  .top-bar-right {
    gap: 15px;
  }

  .top-bar-left span {
    font-size: 0.75rem;
  }
  .top-bar-left span:first-of-type,
  .top-bar-icon:first-of-type {
    display: none;
  }
  .dropdown-content {
    position: static;
    visibility: visible;
    opacity: 1;
    transform: none;
    box-shadow: none;
    width: 100%;
    margin-top: 0;
    padding: 0;
    display: none;
    border-radius: 0;
  }

  .dropdown-content::before {
    display: none;
  }

  .dropdown:hover .dropdown-content {
    display: none;
  }

  .dropdown.open .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .dropdown-content a,
  .dropdown-content .a {
    padding: 1rem 2rem !important;
    font-size: 0.85rem !important;
    border-bottom: 1px solid #eee;
  }

  .dropdown-content a:last-child,
  .dropdown-content .a:last-child {
    border-bottom: none;
  }

  .dropdown-content a:hover,
  .dropdown-content .a:hover {
    background-color: #f0f0f0;
    padding-left: 2.5rem !important;
  }
  .read-more-btn {
    display: block;
  }
  .menuToggleBtn {
    display: block;
  }

  nav {
    position: relative;
    padding-right: 50px;
    background-color: white;
  }
  .logo {
    margin-right: auto;
  }
  /* Mobile styles for dropdown (768px and below) */
  .nav-links li a {
    padding: 0.7rem 1rem;
    display: block;
    width: 100%;
    text-align: left;
  }

  .dropdown > a {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown-content {
    position: static;
    visibility: visible;
    opacity: 1;
    transform: none;
    box-shadow: none;
    width: 100%;
    margin-top: 0;
    padding: 0;
    display: none;
    border-radius: 0;
  }

  .dropdown-content::before {
    display: none;
  }

  .dropdown:hover .dropdown-content {
    display: none;
  }

  .dropdown.open .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .dropdown-content a,
  .dropdown-content .a {
    padding: 0.8rem 1.5rem !important;
    font-size: 0.85rem !important;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }

  .dropdown-content a:last-child,
  .dropdown-content .a:last-child {
    border-bottom: none;
  }

  .dropdown-content a:hover,
  .dropdown-content .a:hover {
    background-color: #f0f0f0;
    padding-left: 2rem !important;
  }
}

/* 작은 모바일: max-width 480px */
@media (max-width: 480px) {
  body {
    padding-top: 90px;
  }
  .container {
    width: 100%;
    padding: 10px !important;
    margin: 0 auto;
  }
  .container-full {
    width: 100%;
  }

  header,
  header.home-header {
    top: 0 !important;
    height: 80px;
    position: fixed;
    width: 100%;
    z-index: 1000;
  }
  .top-bar {
    display: none;
  }

  nav {
    padding: 1rem 0.8rem;
    justify-content: center;
    position: relative;
  }
  .logo {
    position: relative;
    left: 10px;
    display: flex;
    align-items: center;
  }

  .logo a {
    font-size: 1.2rem;
    gap: 8px;
    display: flex;
    align-items: center;
  }

  .logo-text {
    font-size: 1.2rem;
  }

  .logo-image {
    height: 35px;
    width: auto;
  }

  h2 {
    font-size: 1.2rem;
  }

  nav {
    position: relative;
  }
  .nav-links {
    width: 200px;
  }
  .nav-links li a {
    font-size: 0.9rem;
  }
  .nav-links li a.plan-trip,
  .nav-links li a.contact-us {
    padding: 0.4rem 0.8rem;
  }
  menuToggleBtn {
    right: 0px;
    font-size: 20 px;
  }
  .destinations h2,
  .reviews-header h2,
  .section-header h2,
  .activities-header h2,
  .articles-section-title h2,
  .popular-tours-title h2,
  .why-choose-us h2 {
    font-size: 1.5rem;
  }

  #hero h1 {
    font-size: 2.5rem;
    padding: 1rem;
  }
  #hero p {
    font-size: 1rem;
  }
  #hero button {
    padding: 0.5rem 1rem;
  }
  #why-choose-us {
    margin-left: 1rem;
    margin-right: 1rem;
    box-sizing: border-box;
  }
  #why-choose-us h2 {
    font-size: 1.3rem;
  }
  .features {
    justify-content: space-between;
    gap: 1rem;
  }
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 0rem;
  }
  .feature-card:nth-child(n + 3) {
    display: none;
  }
  .feature p {
    font-size: 0.8rem;
  }
  .icon {
    width: 60px;
    height: 60px;
    padding: 0.5rem;
  }
  .icon img {
    width: 30px;
    height: 30px;
  }
  /* destinations section */
  .destinations {
    width: 100%;
    margin: 0rem;
    padding: 0.5rem;
  }

  .destinations-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    justify-items: center;
    padding: 0;
  }
  .destination-card {
    width: 100%;
    max-width: 300px;
  }
  #destinations {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    padding: 0;
  }
  .card {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 1/1;
  }

  .card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .card-title {
    position: absolute;
    bottom: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 0.3rem 0.8rem;
    border-radius: 5px;
    text-align: center;
    font-size: 1rem;
    width: auto;
  }

  .card-title span {
    display: none;
  }

  /* activities section */
  .list-container {
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    gap: 10px;
    grid-template-areas:
      "national-parks lake-activities"
      "food lake-activities"
      "city-tours city-tours"
      "hiking dance";
  }
  .list {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 10px;
  }

  .list img {
    border-radius: 5px;
  }

  .list-title {
    font-size: 0.8rem;
    padding: 0.5rem;
  }
  /* reviews section */
  .reviews-section {
    padding: 0.5rem;
  }
  .reviews-grid {
    display: flex;
    overflow-x: auto;
    gap: 0rem;
    padding: 0;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  .reviews-grid::-webkit-scrollbar {
    display: none;
  }
  .review-card {
    width: 100%;
    flex: 0 0 auto;
    scroll-snap-align: start;
  }
  #ourpartners h2 {
    font-size: 1.8rem;
  }

  /*responsiveness of articles section*/
  .articles-section-title {
    margin-bottom: 0.5rem;
  }
  .articles-section-title h2 {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }
  .article-card {
    min-width: 150px;
  }
  .article-image {
    height: 150px;
  }

  .article-date {
    font-size: 0.75rem;
  }

  .article-title {
    font-size: 0.8rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 2.4rem; /* Approximately 2 lines of text */
    margin-bottom: 0.3rem;
  }
  .article-info p {
    font-size: 0.7rem;
  }
  .article-card:nth-child(n + 3) {
    display: none;
  }

  .articles-list {
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow-x: auto;
    gap: 1rem;
    display: flex;
  }
  .read-more-button {
    font-size: 0.8rem;
  }
  .read-more-icon {
    font-size: 0.5rem;
    margin-left: 0.2rem;
  }
  /* Section: Banner */
  .text-section {
    padding: 1rem 0.5rem;
  }

  .text-section h2 {
    font-size: 1.2em;
  }
  .text-section p {
    font-size: 0.8em;
  }
  .book-now {
    font-size: 0.9em;
    padding: 5px 10px;
  }
  .image-section img {
    height: auto;
  }

  .section-header {
    margin-bottom: 3rem;
  }

  .section-header h2 {
    font-size: 1.8rem;
  }

  .testimonial-text {
    font-size: 1rem;
  }

  .subscribe-section {
    padding: 0.5rem;
  }
  .subscribe-section h3 {
    font-size: 1.2rem;
  }
  .subscribe-section p {
    font-size: 0.8rem;
  }
  .subscribe-form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .subscribe-form input {
    width: 100%;
  }

  /* View All Buttons */
  .view-all-button,
  .view-all-activities,
  .articles-view-all-button {
    padding: 0.5rem 1.5rem;
    font-size: 0.8rem;
    margin-top: 1rem;
    border: 1px solid #e8c140;
  }

  .view-all-container,
  .articles-view-all-container {
    margin-top: 1rem;
    padding: 0 0.5rem;
  }

  .view-all-container .view-all-button {
    padding: 0.5rem 1.5rem;
    font-size: 0.8rem;
  }

  /* Activities Section */
  .section.activities {
    padding: 0 0.5rem;
  }

  .list-container {
    padding: 0;
    margin: 0;
    gap: 10px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 180px);
    border: none;
  }
  .list:nth-child(n + 4) {
    display: none;
  }

  .list:nth-child(1) {
    grid-column: 1 / span 2;
    grid-row: 1;
  }
  .list:nth-child(2),
  .list:nth-child(3),
  .list:nth-child(4),
  .list:nth-child(5),
  .list:nth-child(6) {
    grid-column: auto;
    grid-row: auto;
  }
  .list {
    border-radius: 8px;
  }

  .list img {
    height: 100%;
    border-radius: 8px;
  }
  .list-title {
    font-size: 0.9rem;
    padding: 8px;
  }

  /* popular tours section */
  .popular-tours-section {
    padding: 0;
    width: 100%;
    margin: 0 auto;
  }
  .p-tour-link {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 1rem);
    max-width: calc(50% - 1rem);
  }
  .p-tour-list {
    gap: 8px;
    padding: 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .p-tour-list ::-webkit-scrollbar {
    display: none;
  }

  .p-tour-link {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 5px);
    max-width: calc(50% - 5px);
  }

  .p-tour-card {
    border-radius: 8px;
  }

  .p-tour-image {
    height: 120px;
  }

  .p-tour-destination {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
    top: 0.3rem;
    left: 0.3rem;
    border-radius: 7px;
  }

  .p-tour-info {
    padding: 0.6rem;
    height: auto;
    overflow: visible;
  }

  .p-tour-title {
    font-size: 0.8rem;
    margin: 0.2rem 0;
    line-height: 1.5;
    height: 60px;
    line-clamp: 2;
  }

  .p-tour-details {
    padding: 0.4rem;
    border-top: 1px solid #eee;
  }

  .p-tour-days {
    font-size: 0.8rem;
  }

  .p-tour-price {
    font-size: 0.8rem;
  }

  .p-tour-price-text {
    font-size: 0.7rem;
  }

  .p-tour-price span {
    font-size: 0.7rem;
  }

  .view-details-button {
    font-size: 0.7rem;
    padding: 0.5rem;
    border-radius: 5px;
  }

  .popular-tours-title {
    padding: 0;
    margin: 1rem 0;
  }

  .popular-tours-title h2 {
    margin-bottom: 1rem;
  }

  /* banner */
  .banner .icon {
    font-size: 0.5rem;
    width: 40px;
    height: 40px;
  }
  .banner .text-section {
    padding: 0;
  }
  .banner .text-section h2 {
    font-size: 1.2rem;
  }
  .banner .book-now {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
  }
  .banner .text-section p {
    font-size: 0.8rem;
    display: flex;
    flex-direction: row;
  }
  .banner .text-section p span {
    margin-left: 0.5rem;
  }
  .reviews-section {
    padding: 0.5rem;
  }
  .reviews-grid {
    display: flex;
    overflow-x: auto;
    gap: 0rem;
    padding: 0;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .review-text {
    text-align: justify;
  }

  .read-more-btn {
    width: 100%;
    text-align: center;
  }

  .review-author-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .stars {
    justify-content: center;
  }

  .reviews-grid::-webkit-scrollbar {
    display: none;
  }
  .review-card {
    width: 90vw;
    flex: 0 0 90vw;
    scroll-snap-align: start;
    padding: 0.5rem;
    min-width: auto;
    text-align: center;
  }

  .slider-dots {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 15px;
    padding-bottom: 10px;
    position: relative;
    z-index: 2;
  }

  .dot {
    width: 8px;
    height: 8px;
    border: 1px solid #e8c140;
    border-radius: 50%;
    display: block; /* Ensure dots are visible */
  }

  .dot.active {
    background-color: #e8c140;
  }

  .view-all-button,
  .view-all-activities,
  .articles-view-all-button {
    padding: 8px 24px;
    font-size: 0.9rem;
    margin-top: 1rem;
  }

  .view-all-container,
  .articles-view-all-container {
    margin-top: 1rem;
    padding: 0 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/style.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;;EAEE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;AACA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,sKAAsK;EACtK,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2EAA6D;EAC7D,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,kBAAkB;EAClB,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,4CAA4C,EAAE,yBAAyB;AACzE;;AAEA;EACE;oCACkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;oCACkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,2EAA+D;EAC/D,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,wEAAwE;EACxE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE;oCACkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B,EAAE,2CAA2C;EAC3E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;EAC3C,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;oCACkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,6BAA6B;EAC7B,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,8EAA8E;EAC9E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2EAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;oCACkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;oCACkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;oCACkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,2EAAoE;EACpE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,SAAO;EACP,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;EACjB;EACA,aAAa;EACb;IACE,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,SAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,SAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE;;;;;;;IAOE,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;;EAEA,oBAAoB;EACpB;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,MAAM;IACN,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;;IAEE,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA,iDAAiD;EACjD;IACE,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;;IAEE,iCAAiC;IACjC,6BAA6B;IAC7B,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,wBAAwB;IACxB,cAAc;EAChB;EACA;IACE,WAAW;EACb;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;;;;;;;IAOE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,yBAAyB;EACzB;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;IAClC,SAAS;IACT;;;;oBAIgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA,oBAAoB;EACpB;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,iCAAiC;EACnC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,cAAc,EAAE,kCAAkC;IAClD,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;IACT,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA,oBAAoB;EACpB;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA,qBAAqB;EACrB;;;IAGE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,uBAAuB;EACvB;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,SAAS;IACT,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;;;;;IAKE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,UAAU;IACV,WAAW;IACX,cAAc;EAChB;EACA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc,EAAE,4BAA4B;EAC9C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":["/* 기본 리셋 */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: Roboto;\n  line-height: 1.6;\n  padding-top: 110px;\n}\n\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 0rem;\n}\n.home-container {\n  margin-top: -10px;\n}\n\n.container-full {\n  max-width: 1280px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\nsection {\n  margin-bottom: 5rem;\n}\n\nheader {\n  position: fixed;\n  top: 40px;\n  left: 0;\n  width: 100%;\n  background-color: #ffffff;\n  z-index: 1000;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  height: 60px;\n  color: #000;\n  margin: 0;\n  padding: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\nnav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 50px;\n  height: 100%;\n}\n.logo {\n  flex: 0 0 auto;\n}\n\n.logo a {\n  color: #004d00;\n  text-decoration: none;\n  font-family: Anton;\n  font-size: 1.5rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n.logo-text {\n  color: #004d00;\n  font-family: Anton;\n  font-size: 1.5rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.logo-image {\n  height: 40px;\n  width: auto;\n  margin-right: 5px;\n}\n.nav-links {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-left: auto;\n}\n\n.nav-links li {\n  margin: 0;\n}\n\n.nav-links li a {\n  color: #004d00;\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 1rem;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n  padding: 0.7rem 1.2rem;\n}\n.nav-links li a:hover {\n  color: #e8c140;\n}\n\n.nav-links li.btn-yellow a,\n.nav-links li.btn-green a {\n  color: #fff !important;\n}\n\n/* 네비게이션 바 버튼 스타일링 */\n.nav-links li a.plan-trip,\n.nav-links li a.contact-us {\n  padding: 0.5rem 1rem;\n  /* border-radius: 5px; */\n}\n\n.nav-links li a.plan-trip {\n  background: #ff9800;\n  color: #fff;\n}\n.nav-links li a.contact-us {\n  background: #004d00;\n  color: #fff;\n}\n\n.btn-yellow {\n  background: #e8c140;\n  padding: 0.5rem 0.5rem;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-yellow a {\n  color: black !important;\n}\n\n.btn-green {\n  background: #004d00;\n  padding: 0.5rem 0.5rem;\n  border-radius: 10px;\n}\n\n.btn-green a {\n  color: #fff !important;\n}\n/* TopBar styles */\n.top-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  z-index: 1002;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.top-bar-container {\n  max-width: 1280px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 2rem;\n}\n\n.top-bar-left {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.top-bar-right {\n  display: flex;\n  gap: 20px;\n}\n\n.top-bar-icon {\n  margin-right: 8px;\n  font-size: 0.8rem;\n  color: #004d00;\n}\n\n.top-bar-social-icon {\n  font-size: 15px;\n  color: #004d00;\n  transition: color 0.3s ease;\n}\n.top-bar-social-icon:hover {\n  color: #e8c140;\n}\n\n.top-bar-left span {\n  font-family: Poppins, sans-serif;\n  font-weight: 500;\n  color: #004d00;\n  margin-right: 15px;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n}\n\n/* Dropdown styles */\n.dropdown {\n  position: relative;\n}\n\n.dropdown-content {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #fff;\n  min-width: 220px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 0.8rem 0;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n}\n\n/* Arrow for dropdown */\n.dropdown-content::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid #fff;\n}\n\n/* Show dropdown on hover */\n.dropdown:hover .dropdown-content {\n  visibility: visible;\n  opacity: 1;\n  margin-top: 0;\n}\n.dropdown-content a,\n.dropdown-content .a {\n  color: #004d00 !important;\n  padding: 0.8rem 1rem !important;\n  display: block;\n  text-decoration: none;\n  font-size: 0.9rem !important;\n  transition: all 0.3s ease;\n  text-align: left;\n  cursor: pointer;\n}\n\n.dropdown-content a:hover,\n.dropdown-content .a:hover {\n  background-color: #f8f9fa;\n  color: #e8c140 !important;\n  padding-left: 2rem !important;\n}\n\n/* hero section */\n#hero {\n  position: relative;\n  height: 85vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  overflow: hidden;\n  margin-bottom: 0;\n  margin: 0 0 0;\n  z-index: 0;\n}\n\n.hero-slideshow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  opacity: 0;\n  transform: scale(1.1);\n  transition: opacity 2s ease, transform 2s ease;\n}\n\n.slide.active {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.slide::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n#hero .overlay {\n  font-family: Poppins, sans-serif;\n  /* font-family: Picsart-Fonts, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Helvetica, Arabic, sans-serif; */\n  position: relative;\n  padding: 2rem;\n  border-radius: 10px;\n  color: white;\n  max-width: 130vh;\n  margin: 0 auto;\n  padding-top: 60px;\n}\n#hero .overlay button {\n  margin: 0 auto;\n  background-color: transparent;\n  border: 2px solid white;\n  display: block;\n  animation: fadeInUp 1s ease-out 0.6s;\n  opacity: 1;\n  border-radius: 10px;\n  animation-fill-mode: forwards;\n  padding: 0.5rem 1.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 1rem;\n  color: white;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n#hero h1 {\n  font-family: \"Regular Blush\", cursive !important;\n  font-weight: 400;\n  font-size: 5rem;\n  animation: fadeInUp 1s ease-out;\n}\n\n#hero p {\n  font-size: 1.5rem;\n  font-weight: 400;\n  line-height: 2;\n  margin-bottom: 1.5rem;\n  animation: fadeInUp 1s ease-out 0.3s;\n  opacity: 1;\n  animation-fill-mode: forwards;\n}\n#hero .overlay a {\n  text-decoration: none !important;\n  color: inherit;\n}\n#hero .overlay a:hover {\n  text-decoration: none !important;\n}\n#hero .overlay a:visited {\n  color: inherit;\n  text-decoration: none !important;\n}\n\n.whatsapp-icon {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #25d366;\n  color: white;\n  width: auto;\n  padding: 10px 20px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 500;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n.whatsapp-icon svg {\n  font-size: 1.4rem;\n}\n\n.whatsapp-icon:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.4);\n}\n\n.logo-image {\n  max-height: 120px;\n  width: auto;\n  object-fit: contain;\n}\n.wave {\n  position: relative;\n  height: 30px;\n  width: 100%;\n  background: url(\"../images/wave.png\") no-repeat center bottom;\n  background-size: cover;\n  margin-top: -30px;\n  /* 이미지가 겹치도록 설정 */\n}\n\n/* Section: Why Choose Us */\n.why-choose-us {\n  padding: 0px 0;\n  text-align: center;\n  background-image: url(../images/zebra.avif);\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  position: relative;\n  padding-bottom: 2rem;\n}\n.why-choose-us::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(255, 255, 255, 0.972); /* Simple white overlay */\n}\n\n.why-choose-us h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  padding: 0rem 1rem;\n  font-size: 2.5rem;\n  margin-top: 3rem;\n  text-align: center;\n  margin-bottom: 3.5rem;\n  position: relative;\n  color: black;\n  z-index: 2;\n}\n\n.why-choose-us h2:after {\n  content: \"\";\n  position: absolute;\n  bottom: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 30px;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 120px;\n  position: relative;\n  z-index: 2;\n}\n\n.feature-card {\n  text-align: center;\n}\n\n.icon-wrapper {\n  width: 70px;\n  height: 70px;\n  background-color: #004d00;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  color: #fff;\n  font-size: 24px;\n}\n\n.feature-card h3 {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.feature-card p {\n  font-size: 0.9rem;\n  color: #666;\n  line-height: 1.4;\n}\n\n/* PopularTours.js */\n.popular-tours-section {\n  padding: 0rem 0rem;\n  margin-bottom: 2rem;\n}\n\n.popular-tours-title {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  padding: 0rem 1rem;\n  margin-top: 3rem;\n  text-align: center;\n}\n\n.popular-tours-title h2 {\n  font-size: 2.5rem;\n  margin-bottom: 3rem;\n  position: relative;\n}\n\n.popular-tours-title h2:after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n\n.p-tour-destination {\n  font-size: 0.9rem;\n  background-color: #004d00a4;\n  color: white;\n  position: absolute;\n  top: 0.5rem;\n  left: 0.5rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: 5px;\n  font-weight: 500;\n}\n.p-tour-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.p-tour-link {\n  text-decoration: none;\n  color: inherit;\n  flex: 1 1 calc(25% - 1rem);\n  box-sizing: border-box;\n}\n.p-tour-link:nth-child(n + 5) {\n  display: none;\n}\n\n.p-tour-card {\n  position: relative;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.p-tour-image {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.p-tour-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.8s ease;\n}\n\n.p-tour-card:hover .p-tour-image img {\n  transform: scale(1.1);\n}\n\n.p-tour-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid #eee;\n  padding: 0.8rem;\n}\n\n.p-tour-days {\n  font-size: 0.9rem;\n  color: #333;\n}\n.p-tour-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.p-tour-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n.p-tour-info {\n  padding: 0 1rem;\n  height: 180px;\n  overflow-y: auto;\n}\n.p-tour-location {\n  font-size: 0.8rem;\n  color: #555;\n}\n.p-tour-price-text {\n  font-size: 0.9rem;\n  color: #555;\n}\n.p-tour-price span {\n  font-size: 0.9rem;\n  color: #555;\n  font-weight: 500;\n}\n.p-tour-price {\n  font-size: 1 rem;\n  color: #004d00a4;\n  font-weight: 600;\n  font-family: Poppins, sans-serif;\n}\n.p-tour-title {\n  font-size: 0.95rem;\n  font-weight: bold;\n  margin: 0.5rem 0.5rem;\n  height: 60px;\n  text-transform: uppercase;\n}\n\n.p-tour-days {\n  font-size: 0.9rem;\n  color: #333;\n}\n.view-details-button {\n  background: transparent;\n  background-color: #004d00a4;\n  font-size: 0.9rem;\n  padding: 0.5rem 1rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  border-radius: 5px;\n  border: none;\n}\n\n/* Section: Destinations */\n.destinations {\n  background: url(\"../images/map12.avif\") no-repeat center center;\n  background-size: cover;\n  color: black;\n  width: 100%;\n  padding: 2rem 0;\n  border-radius: 1rem;\n  position: relative;\n}\n\n.destinations::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  background-color: rgba(252, 249, 242, 0.99);\n}\n\n/* Make sure content appears above the overlay */\n.destinations h2,\n#destinations {\n  position: relative;\n  z-index: 2;\n}\n\n#destinations {\n  max-width: 1280px;\n  margin: 0 auto;\n  margin-top: 1rem;\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(calc(25% - 1.5rem), 1fr));\n  gap: 2rem;\n  justify-content: space-between;\n}\n.destinations h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  text-align: center;\n  margin-bottom: 3rem;\n  font-size: 2.5rem;\n  position: relative;\n}\n.destinations h2:after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n\n.card {\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  cursor: pointer;\n  /* aspect-ratio: 1 / 1.3; */\n  border-radius: 10px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.5s ease;\n}\n\n.card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6); /* Adjust the color and opacity as needed */\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.card:hover::before {\n  opacity: 1;\n}\n\n.card-title {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: white;\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n  z-index: 2;\n  transition: transform 0.4s ease, opacity 0.4s ease;\n}\n\n.card:hover .card-title {\n  transform: translate(-50%, -50%);\n  top: 50%;\n  opacity: 1;\n}\n\n.card-title span {\n  display: flex;\n  font-size: 0.9rem;\n  align-items: center;\n  gap: 0.3rem;\n  margin-left: 0.3rem;\n}\n\n/* Section: Activities */\n.section.activities {\n  padding: 0rem 2rem;\n}\n.activities-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.activities-header h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  padding: 0rem 1rem;\n  font-size: 2.5rem;\n  margin-bottom: 3rem;\n  position: relative;\n  text-align: center;\n}\n\n.activities-header h2:after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n/* View All Button Styles */\n.view-all-button,\n.view-all-activities,\n.articles-view-all-button {\n  align-items: center;\n  display: block;\n  margin: 2rem auto 0;\n  padding: 8px 30px;\n  background-color: transparent;\n  border: 2px solid #e8c140;\n  font-size: 0.9rem;\n  font-weight: 500;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  text-align: center;\n  color: #666 !important;\n}\n\n.view-all-button:hover,\n.view-all-activities:hover,\n.articles-view-all-button:hover {\n  background-color: #e8c140;\n  color: white !important;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(232, 193, 64, 0.3);\n}\n\n/* Container styles for view all buttons */\n.view-all-container,\n.articles-view-all-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.list-container {\n  padding: 0rem 1rem;\n  margin-top: 1.5rem;\n  display: grid;\n  grid-template-columns: 0.6fr 1fr 0.8fr 0.8fr;\n  grid-template-rows: auto auto;\n  grid-template-rows: repeat(2, 220px);\n  gap: 20px;\n}\n\n.list {\n  background-color: white;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.list img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 10px;\n}\n.list-title {\n  font-family: Poppins, sans-serif;\n  color: white;\n  font-size: 1.2rem;\n  padding: 10px;\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  font-weight: 700;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);\n  transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease;\n  z-index: 2;\n  background-color: transparent;\n}\n\n.list:hover .list-title {\n  bottom: 50%;\n  transform: translate(-50%, 50%);\n  background-color: rgba(0, 0, 0, 0.3);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n}\n\n/* Assign grid positions */\n.list:nth-child(1) {\n  grid-column: 1;\n}\n\n.list:nth-child(2) {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n}\n\n.list:nth-child(3) {\n  grid-column: 3 / span 2;\n  grid-row: 1;\n}\n\n.list:nth-child(4) {\n  grid-column: 1;\n  grid-row: 2;\n}\n\n.list:nth-child(5) {\n  grid-column: 3;\n  grid-row: 2;\n}\n\n.list:nth-child(6) {\n  grid-column: 4;\n  grid-row: 2;\n}\n\n.modal {\n  position: fixed;\n  z-index: 999;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  width: 80%;\n  max-height: 80%;\n  overflow-y: auto;\n  position: relative;\n  border-radius: 10px;\n}\n\n.close-icon {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  font-size: 24px;\n  cursor: pointer;\n  color: #333;\n  transition: color 0.3s;\n}\n\n.close-icon:hover {\n  color: #e8c140;\n}\n\n.modal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 10px;\n  margin-top: 40px;\n}\n\n.modal-list {\n  background-color: white;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.modal-list img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 10px;\n}\n\n.activities-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Section: Banner */\n.banner {\n  font-family: \"Lato\", sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 400px;\n  margin: 60px auto;\n  padding: 20px;\n  background: linear-gradient(to right, #eedbb733, #efca85dd);\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n}\n.banner .text-section {\n  text-align: center;\n}\n.banner::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 50%;\n  height: 100%;\n  background: url(\"../images/banner1.jpg\") no-repeat center center;\n  background-size: cover;\n  filter: brightness(0.7);\n  z-index: 1;\n}\n\n.text-section {\n  position: relative;\n  z-index: 2;\n  max-width: 50%;\n  padding: 20px;\n}\n\n.text-section h2 {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin-bottom: 2rem;\n  color: #333;\n}\n\n.text-section p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 20px;\n  color: #555;\n}\n\n.book-now {\n  background-color: white;\n  border: 2px solid #e8c140;\n  color: #e8c140;\n  padding: 12px 24px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.book-now:hover {\n  background-color: #d1a837;\n  transform: scale(1.05);\n}\n\n.icon {\n  margin-right: 8px;\n  color: #e8c140;\n}\n\n/* Section: Partners */\n.partners {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  overflow-x: auto;\n  padding: 2rem 1rem;\n}\n#ourpartners h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  font-size: 2.5rem;\n  position: relative;\n  margin: 2rem auto;\n}\n#ourpartners h2::after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n\n/* Section: Articles */\n.articles-section {\n  text-align: left;\n  padding: 2rem 0;\n}\n\n.articles-section-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.articles-section-title h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  font-size: 2.5rem;\n  position: relative;\n  margin: 0 auto;\n}\n\n.articles-section-title h2::after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n.articles-view-all-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.articles-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  gap: 2rem;\n}\n\n.article-card {\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  width: calc(33.33% - 1rem);\n  margin-bottom: 2rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.article-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.article-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.article-info {\n  padding: 1rem;\n  text-align: left;\n}\n\n.article-date {\n  color: #777;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.article-title {\n  font-size: 1.125rem;\n  margin: 0.5rem 0;\n  color: #333;\n}\n.article-excerpt {\n  color: #777;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.read-more-button {\n  display: inline-block;\n  color: #e8c140;\n  font-weight: bold;\n  border: none;\n  background-color: transparent;\n  text-decoration: none;\n  margin-top: 0.5rem;\n  padding: 0.5rem 0.5rem;\n  border-radius: 10px;\n}\n\n.read-more-button:hover {\n  text-decoration: underline;\n}\n\n.articles-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-between;\n}\n.subscribe-section {\n  font-family: \"Lato\", sans-serif;\n  background-color: #f8f9fa;\n  padding: 2rem;\n  text-align: center;\n  margin-top: 2rem;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n}\n.subscribe-section h3 {\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n.subscribe-section p {\n  font-size: 1rem;\n  color: #777;\n}\n.subscribe-form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n.subscribe-form input {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 250px;\n}\n.subscribe-form button {\n  color: white;\n  font-weight: 500;\n  font-size: 0.9rem;\n  padding: 0.5rem 0.5rem;\n  border-radius: 4px;\n  background-color: #e8c140;\n  border: none;\n}\n/* Reviews Section */\n\n.reviews-header {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.reviews-header h2 {\n  font-family: \"Trebuchet MS\", \"Lucida Sans Unicode\", \"Lucida Grande\",\n    \"Lucida Sans\", Arial, sans-serif;\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.reviews-header h2:after {\n  content: \"\";\n  position: absolute;\n  bottom: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 3px;\n  background: #e8c140;\n}\n\n.reviews-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0;\n  position: relative;\n  z-index: 2;\n}\n\n.review-card {\n  padding: 2rem;\n  text-align: left;\n  color: #000;\n}\n\n.stars {\n  color: #e8c140;\n  font-size: 1.35rem;\n  margin-bottom: 1rem;\n}\n.rating-value {\n  font-size: 1rem;\n  color: #666;\n  margin-left: 0.25rem;\n}\n\n.review-text {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #000;\n  margin-bottom: 1rem;\n  transition: max-height 0.3s ease-out;\n  text-align: justify;\n}\n.review-author-info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n.review-author-info img {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  object-position: top center;\n  border-radius: 50%;\n}\n.review-author-info h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.review-author-info span {\n  color: #666;\n  font-size: 0.9rem;\n}\n.review-text.expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n  max-height: none;\n}\n\n.read-more-btn {\n  display: none;\n  color: #666;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n/* Footer */\n.footer {\n  background-color: #004d00;\n  color: white;\n  padding: 1rem 0;\n  margin-top: 2rem;\n  font-size: 0.8rem;\n}\n.wave-footer {\n  position: relative;\n  height: 3rem;\n  width: 100%;\n  background: url(\"../images/wave_footer.png\") no-repeat center bottom;\n  background-size: cover;\n  margin-top: -1rem;\n}\n\n.footer-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.footer-column {\n  flex: 1;\n  min-width: 200px;\n  margin: 20px;\n}\n\n.footer-column h3 {\n  margin-bottom: 20px;\n}\n\n#contact {\n  flex: 3;\n}\n\n.footer-column p,\n.footer-column ul,\n.footer-column form {\n  margin-bottom: 20px;\n}\n\n.footer-column ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-column ul li {\n  margin-bottom: 10px;\n}\n\n.footer-column ul li a {\n  color: white;\n  text-decoration: none;\n}\n\n.footer-column ul li a:hover {\n  text-decoration: underline;\n}\n\n#newsletter {\n  flex: 3;\n}\n\n#h3-follow {\n  font-size: 1.5rem;\n}\n\n/* 뉴스레터 폼 스타일링 */\n.newsletter-form {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  flex-direction: row;\n  /* 한 줄로 배 */\n}\n\n.newsletter-form input[type=\"email\"] {\n  width: 10rem;\n  border: none;\n  padding: 10px;\n  flex: 1;\n  border-radius: 5px 0 0 5px;\n  /* 왼쪽 모서리만 둥게 */\n}\n\n.newsletter-form input[type=\"email\"]:focus {\n  border: none;\n}\n\n#newsletter-submit {\n  background-color: #fff;\n  color: black;\n  border: none;\n  padding: 10px 20px;\n  /* 좌우 패딩 추가 */\n  cursor: pointer;\n  border-radius: 0 5px 5px 0;\n  /* 오른쪽 모서리만 둥글게 */\n  font-size: 1rem;\n}\n\n.newsletter-form button:hover {\n  text-decoration: underline;\n  background-color: #fff;\n}\n\n.social-icons {\n  display: flex;\n  gap: 10px;\n}\n\n.social-icons a {\n  display: inline-block;\n}\n\n.social-icons img {\n  width: 24px;\n  height: 24px;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding: 20px 0;\n  color: white;\n}\n\n/* 링크 색상 및 데코레이션 설정 */\n.footer a {\n  color: white;\n  text-decoration: none;\n}\n\n.footer a:hover {\n  text-decoration: none;\n  color: white;\n}\n.menuToggleBtn {\n  background: none;\n  border: none;\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 25px;\n  color: #004d00;\n  padding: 0 10px;\n  display: none;\n}\n\n/* 태블릿: max-width 1024px */\n@media (max-width: 1024px) {\n  .logo {\n    margin-right: auto;\n  }\n  .nav-links {\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n    margin-left: auto;\n  }\n  nav {\n    display: flex;\n    justify-content: space-between;\n  }\n  .nav-links li a {\n    padding: 0.5rem 0.5rem;\n  }\n  .features {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 2rem;\n  }\n  .feature {\n    flex: 1 1 calc(30% - 0.25rem);\n    max-width: calc(30% - 0.25rem);\n    aspect-ratio: 1/1;\n  }\n  #why-choose-us {\n    margin-left: 3rem;\n    margin-right: 3rem;\n    box-sizing: border-box;\n    object-fit: cover;\n  }\n\n  .top {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 0 1rem;\n  }\n  /* articles */\n  .articles-list {\n    gap: 1rem;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n  }\n  .article-card {\n    min-width: 260px;\n    flex: 1 1 0;\n  }\n  .article-image {\n    height: auto;\n  }\n  .article-card:nth-child(n + 4) {\n    display: none;\n  }\n  .testimonials-container {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2rem;\n    padding: 0 1rem;\n  }\n  .top-bar {\n    padding: 8px 15px;\n  }\n\n  .top-bar-left {\n    gap: 10px;\n  }\n\n  .top-bar-left span {\n    font-size: 0.8rem;\n  }\n  .features-grid {\n    padding: 0 4rem;\n  }\n  .subscribe-section {\n    flex-direction: column;\n  }\n  .subscribe-form input {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .reviews-grid {\n    grid-auto-rows: 1fr;\n    padding: 0 1rem;\n  }\n\n  .reviews-header h2 {\n    font-size: 2rem;\n  }\n}\n\n@media (min-width: 800px) and (max-width: 1024px) {\n  .top {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    padding: 0 1rem;\n  }\n  .top-bar {\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 5px 10px;\n  }\n\n  .top-bar-left {\n    flex-wrap: nowrap;\n    gap: 8px;\n  }\n\n  .top-bar-right {\n    gap: 15px;\n  }\n\n  .top-bar-left span {\n    font-size: 0.75rem;\n  }\n  .top-bar-left span:first-of-type,\n  .top-bar-icon:first-of-type {\n    display: none;\n  }\n  .logo-text {\n    font-size: 1.2rem;\n  }\n  .features-grid {\n    padding: 0 2rem;\n    grid-template-columns: repeat(3, 1fr);\n    align-items: center;\n  }\n\n  .p-tour-list {\n    padding: 1rem;\n  }\n  .p-tour-link {\n    text-decoration: none;\n    color: inherit;\n    flex: 1 1 calc(33.33% - 1rem);\n    box-sizing: border-box;\n  }\n  .p-tour-link:nth-child(n + 4) {\n    display: none;\n  }\n  .reviews-grid {\n    padding: 0 1rem;\n  }\n  .review-card {\n    padding: 0;\n  }\n  .articles-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1rem;\n    justify-content: center;\n    padding: 1rem;\n  }\n  .article-card {\n    min-width: 260px;\n    flex: 1 1 0;\n  }\n}\n\n/* 모바일: max-width 768px */\n@media (max-width: 768px) {\n  .destinations h2,\n  .reviews-header h2,\n  .section-header h2,\n  .activities-header h2,\n  .articles-section-title h2,\n  .popular-tours-title h2,\n  .why-choose-us h2 {\n    font-size: 2rem;\n  }\n  .top {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    padding: 0 1rem;\n  }\n  .logo-image {\n    max-height: 50px;\n  }\n  .container {\n    width: 95%;\n  }\n  nav {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n  .logo {\n    margin-right: auto;\n  }\n  .nav-links {\n    position: absolute;\n    top: 100%;\n    right: 15px;\n    gap: 0;\n    padding: 1rem;\n    background-color: #fff;\n    flex-direction: column;\n    width: 250px;\n    z-index: 1003;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n    border-radius: 0 0 10px 10px;\n  }\n  .nav-links li {\n    margin: 0.5rem 0;\n    width: 100%;\n    text-align: left;\n  }\n  .nav-links li a {\n    white-space: nowrap;\n  }\n\n  .menuToggleBtn {\n    cursor: pointer;\n    z-index: 1004;\n  }\n  .menuToggleBtn {\n    display: block;\n  }\n  .nav-links {\n    display: none;\n  }\n  .nav-links.open {\n    display: flex;\n  }\n\n  #hero h1 {\n    font-size: 3rem;\n  }\n  #hero p {\n    font-size: 1rem;\n  }\n  .features {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  .features-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    padding: 0 2rem;\n  }\n  .feature-card:nth-child(n + 4) {\n    display: none;\n  }\n  .feature p {\n    font-size: 0.8rem;\n    white-space: wrap;\n  }\n  #why-choose-us {\n    margin-left: 3rem;\n    margin-right: 3rem;\n    box-sizing: border-box;\n    object-fit: cover;\n  }\n  .p-tour-link {\n    flex: 1 1 calc(33.33% - 1rem);\n  }\n  .p-tour-link:nth-child(n + 4) {\n    display: none;\n  }\n  .p-tour-image {\n    height: 150px;\n  }\n  .p-tour-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n\n  .p-tour-link {\n    flex: 1 1 calc(33.33% - 1rem);\n    max-width: calc(33.33% - 1rem);\n  }\n\n  .p-tour-link:nth-child(n + 4) {\n    display: none;\n  }\n\n  .p-tour-card {\n    height: 100%;\n  }\n\n  .p-tour-image {\n    height: 180px;\n  }\n\n  .p-tour-info {\n    padding: 0.5rem;\n    height: auto;\n  }\n\n  .p-tour-title {\n    font-size: 0.9rem;\n    height: auto;\n    margin-bottom: 0.5rem;\n  }\n\n  .p-tour-price-text,\n  .p-tour-price span {\n    font-size: 0.8rem;\n  }\n  .p-tour-price {\n    font-size: 0.9rem;\n  }\n  .view-details-button {\n    font-size: 0.8rem;\n  }\n\n  #destinations {\n    gap: 0.5rem;\n    padding: 0.5rem;\n    margin-top: 0.5rem;\n  }\n  .card-title {\n    padding: 0.5rem;\n    font-size: 1rem;\n    bottom: 1rem;\n    border-radius: 10px;\n  }\n  .card-title span {\n    font-size: 0.7rem;\n    margin: 0;\n  }\n  .card img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .article-card {\n    min-width: 210px;\n  }\n  .article-image {\n    height: auto;\n  }\n  .article-card:nth-child(n + 4) {\n    display: none;\n  }\n  .articles-list {\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    overflow-x: auto;\n    gap: 1;\n    display: flex;\n  }\n\n  /* Section: Banner */\n  .text-section {\n    padding: 1rem;\n  }\n  .text-section h2 {\n    font-size: 1.5em;\n  }\n  .text-section p {\n    font-size: 1em;\n  }\n  .book-now {\n    font-size: 1em;\n    padding: 8px 16px;\n  }\n  .image-container {\n    height: auto;\n  }\n  .image-section img {\n    border-radius: 0;\n  }\n  .reviews-section {\n    padding: 4rem 1rem;\n  }\n  .review-text {\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n    -webkit-line-clamp: 6;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n  }\n  .reviews-grid {\n    gap: 0;\n    padding: 0;\n  }\n  .testimonials-container {\n    grid-template-columns: 1fr;\n  }\n\n  .testimonial-card {\n    padding: 2rem;\n  }\n\n  .quote-icon {\n    font-size: 1.5rem;\n    top: 1.5rem;\n    right: 1.5rem;\n  }\n  .top-bar {\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 5px 10px;\n  }\n\n  .top-bar-left {\n    flex-wrap: nowrap;\n    gap: 8px;\n  }\n\n  .top-bar-right {\n    gap: 15px;\n  }\n\n  .top-bar-left span {\n    font-size: 0.75rem;\n  }\n  .top-bar-left span:first-of-type,\n  .top-bar-icon:first-of-type {\n    display: none;\n  }\n  .dropdown-content {\n    position: static;\n    visibility: visible;\n    opacity: 1;\n    transform: none;\n    box-shadow: none;\n    width: 100%;\n    margin-top: 0;\n    padding: 0;\n    display: none;\n    border-radius: 0;\n  }\n\n  .dropdown-content::before {\n    display: none;\n  }\n\n  .dropdown:hover .dropdown-content {\n    display: none;\n  }\n\n  .dropdown.open .dropdown-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .dropdown-content a,\n  .dropdown-content .a {\n    padding: 1rem 2rem !important;\n    font-size: 0.85rem !important;\n    border-bottom: 1px solid #eee;\n  }\n\n  .dropdown-content a:last-child,\n  .dropdown-content .a:last-child {\n    border-bottom: none;\n  }\n\n  .dropdown-content a:hover,\n  .dropdown-content .a:hover {\n    background-color: #f0f0f0;\n    padding-left: 2.5rem !important;\n  }\n  .read-more-btn {\n    display: block;\n  }\n  .menuToggleBtn {\n    display: block;\n  }\n\n  nav {\n    position: relative;\n    padding-right: 50px;\n    background-color: white;\n  }\n  .logo {\n    margin-right: auto;\n  }\n  /* Mobile styles for dropdown (768px and below) */\n  .nav-links li a {\n    padding: 0.7rem 1rem;\n    display: block;\n    width: 100%;\n    text-align: left;\n  }\n\n  .dropdown > a {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .dropdown-content {\n    position: static;\n    visibility: visible;\n    opacity: 1;\n    transform: none;\n    box-shadow: none;\n    width: 100%;\n    margin-top: 0;\n    padding: 0;\n    display: none;\n    border-radius: 0;\n  }\n\n  .dropdown-content::before {\n    display: none;\n  }\n\n  .dropdown:hover .dropdown-content {\n    display: none;\n  }\n\n  .dropdown.open .dropdown-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .dropdown-content a,\n  .dropdown-content .a {\n    padding: 0.8rem 1.5rem !important;\n    font-size: 0.85rem !important;\n    border-bottom: 1px solid #eee;\n    cursor: pointer;\n  }\n\n  .dropdown-content a:last-child,\n  .dropdown-content .a:last-child {\n    border-bottom: none;\n  }\n\n  .dropdown-content a:hover,\n  .dropdown-content .a:hover {\n    background-color: #f0f0f0;\n    padding-left: 2rem !important;\n  }\n}\n\n/* 작은 모바일: max-width 480px */\n@media (max-width: 480px) {\n  body {\n    padding-top: 90px;\n  }\n  .container {\n    width: 100%;\n    padding: 10px !important;\n    margin: 0 auto;\n  }\n  .container-full {\n    width: 100%;\n  }\n\n  header,\n  header.home-header {\n    top: 0 !important;\n    height: 80px;\n    position: fixed;\n    width: 100%;\n    z-index: 1000;\n  }\n  .top-bar {\n    display: none;\n  }\n\n  nav {\n    padding: 1rem 0.8rem;\n    justify-content: center;\n    position: relative;\n  }\n  .logo {\n    position: relative;\n    left: 10px;\n    display: flex;\n    align-items: center;\n  }\n\n  .logo a {\n    font-size: 1.2rem;\n    gap: 8px;\n    display: flex;\n    align-items: center;\n  }\n\n  .logo-text {\n    font-size: 1.2rem;\n  }\n\n  .logo-image {\n    height: 35px;\n    width: auto;\n  }\n\n  h2 {\n    font-size: 1.2rem;\n  }\n\n  nav {\n    position: relative;\n  }\n  .nav-links {\n    width: 200px;\n  }\n  .nav-links li a {\n    font-size: 0.9rem;\n  }\n  .nav-links li a.plan-trip,\n  .nav-links li a.contact-us {\n    padding: 0.4rem 0.8rem;\n  }\n  menuToggleBtn {\n    right: 0px;\n    font-size: 20 px;\n  }\n  .destinations h2,\n  .reviews-header h2,\n  .section-header h2,\n  .activities-header h2,\n  .articles-section-title h2,\n  .popular-tours-title h2,\n  .why-choose-us h2 {\n    font-size: 1.5rem;\n  }\n\n  #hero h1 {\n    font-size: 2.5rem;\n    padding: 1rem;\n  }\n  #hero p {\n    font-size: 1rem;\n  }\n  #hero button {\n    padding: 0.5rem 1rem;\n  }\n  #why-choose-us {\n    margin-left: 1rem;\n    margin-right: 1rem;\n    box-sizing: border-box;\n  }\n  #why-choose-us h2 {\n    font-size: 1.3rem;\n  }\n  .features {\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  .features-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n    padding: 0 0rem;\n  }\n  .feature-card:nth-child(n + 3) {\n    display: none;\n  }\n  .feature p {\n    font-size: 0.8rem;\n  }\n  .icon {\n    width: 60px;\n    height: 60px;\n    padding: 0.5rem;\n  }\n  .icon img {\n    width: 30px;\n    height: 30px;\n  }\n  /* destinations section */\n  .destinations {\n    width: 100%;\n    margin: 0rem;\n    padding: 0.5rem;\n  }\n\n  .destinations-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    justify-items: center;\n    padding: 0;\n  }\n  .destination-card {\n    width: 100%;\n    max-width: 300px;\n  }\n  #destinations {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n    padding: 0;\n  }\n  .card {\n    position: relative;\n    border-radius: 8px;\n    overflow: hidden;\n    aspect-ratio: 1/1;\n  }\n\n  .card img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .card-title {\n    position: absolute;\n    bottom: 0.5rem;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 0.3rem 0.8rem;\n    border-radius: 5px;\n    text-align: center;\n    font-size: 1rem;\n    width: auto;\n  }\n\n  .card-title span {\n    display: none;\n  }\n\n  /* activities section */\n  .list-container {\n    margin-top: 1.5rem;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto auto;\n    gap: 10px;\n    grid-template-areas:\n      \"national-parks lake-activities\"\n      \"food lake-activities\"\n      \"city-tours city-tours\"\n      \"hiking dance\";\n  }\n  .list {\n    width: 100%;\n    height: 100%;\n    display: block;\n    border-radius: 10px;\n  }\n\n  .list img {\n    border-radius: 5px;\n  }\n\n  .list-title {\n    font-size: 0.8rem;\n    padding: 0.5rem;\n  }\n  /* reviews section */\n  .reviews-section {\n    padding: 0.5rem;\n  }\n  .reviews-grid {\n    display: flex;\n    overflow-x: auto;\n    gap: 0rem;\n    padding: 0;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n  }\n  .reviews-grid::-webkit-scrollbar {\n    display: none;\n  }\n  .review-card {\n    width: 100%;\n    flex: 0 0 auto;\n    scroll-snap-align: start;\n  }\n  #ourpartners h2 {\n    font-size: 1.8rem;\n  }\n\n  /*responsiveness of articles section*/\n  .articles-section-title {\n    margin-bottom: 0.5rem;\n  }\n  .articles-section-title h2 {\n    font-size: 1.8rem;\n    margin-bottom: 0.5rem;\n  }\n  .article-card {\n    min-width: 150px;\n  }\n  .article-image {\n    height: 150px;\n  }\n\n  .article-date {\n    font-size: 0.75rem;\n  }\n\n  .article-title {\n    font-size: 0.8rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    height: 2.4rem; /* Approximately 2 lines of text */\n    margin-bottom: 0.3rem;\n  }\n  .article-info p {\n    font-size: 0.7rem;\n  }\n  .article-card:nth-child(n + 3) {\n    display: none;\n  }\n\n  .articles-list {\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    overflow-x: auto;\n    gap: 1rem;\n    display: flex;\n  }\n  .read-more-button {\n    font-size: 0.8rem;\n  }\n  .read-more-icon {\n    font-size: 0.5rem;\n    margin-left: 0.2rem;\n  }\n  /* Section: Banner */\n  .text-section {\n    padding: 1rem 0.5rem;\n  }\n\n  .text-section h2 {\n    font-size: 1.2em;\n  }\n  .text-section p {\n    font-size: 0.8em;\n  }\n  .book-now {\n    font-size: 0.9em;\n    padding: 5px 10px;\n  }\n  .image-section img {\n    height: auto;\n  }\n\n  .section-header {\n    margin-bottom: 3rem;\n  }\n\n  .section-header h2 {\n    font-size: 1.8rem;\n  }\n\n  .testimonial-text {\n    font-size: 1rem;\n  }\n\n  .subscribe-section {\n    padding: 0.5rem;\n  }\n  .subscribe-section h3 {\n    font-size: 1.2rem;\n  }\n  .subscribe-section p {\n    font-size: 0.8rem;\n  }\n  .subscribe-form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n  .subscribe-form input {\n    width: 100%;\n  }\n\n  /* View All Buttons */\n  .view-all-button,\n  .view-all-activities,\n  .articles-view-all-button {\n    padding: 0.5rem 1.5rem;\n    font-size: 0.8rem;\n    margin-top: 1rem;\n    border: 1px solid #e8c140;\n  }\n\n  .view-all-container,\n  .articles-view-all-container {\n    margin-top: 1rem;\n    padding: 0 0.5rem;\n  }\n\n  .view-all-container .view-all-button {\n    padding: 0.5rem 1.5rem;\n    font-size: 0.8rem;\n  }\n\n  /* Activities Section */\n  .section.activities {\n    padding: 0 0.5rem;\n  }\n\n  .list-container {\n    padding: 0;\n    margin: 0;\n    gap: 10px;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(2, 180px);\n    border: none;\n  }\n  .list:nth-child(n + 4) {\n    display: none;\n  }\n\n  .list:nth-child(1) {\n    grid-column: 1 / span 2;\n    grid-row: 1;\n  }\n  .list:nth-child(2),\n  .list:nth-child(3),\n  .list:nth-child(4),\n  .list:nth-child(5),\n  .list:nth-child(6) {\n    grid-column: auto;\n    grid-row: auto;\n  }\n  .list {\n    border-radius: 8px;\n  }\n\n  .list img {\n    height: 100%;\n    border-radius: 8px;\n  }\n  .list-title {\n    font-size: 0.9rem;\n    padding: 8px;\n  }\n\n  /* popular tours section */\n  .popular-tours-section {\n    padding: 0;\n    width: 100%;\n    margin: 0 auto;\n  }\n  .p-tour-link {\n    flex: 1 1 calc(50% - 1rem);\n    max-width: calc(50% - 1rem);\n  }\n  .p-tour-list {\n    gap: 8px;\n    padding: 0;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .p-tour-list ::-webkit-scrollbar {\n    display: none;\n  }\n\n  .p-tour-link {\n    flex: 0 0 calc(50% - 5px);\n    max-width: calc(50% - 5px);\n  }\n\n  .p-tour-card {\n    border-radius: 8px;\n  }\n\n  .p-tour-image {\n    height: 120px;\n  }\n\n  .p-tour-destination {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.4rem;\n    top: 0.3rem;\n    left: 0.3rem;\n    border-radius: 7px;\n  }\n\n  .p-tour-info {\n    padding: 0.6rem;\n    height: auto;\n    overflow: visible;\n  }\n\n  .p-tour-title {\n    font-size: 0.8rem;\n    margin: 0.2rem 0;\n    line-height: 1.5;\n    height: 60px;\n    line-clamp: 2;\n  }\n\n  .p-tour-details {\n    padding: 0.4rem;\n    border-top: 1px solid #eee;\n  }\n\n  .p-tour-days {\n    font-size: 0.8rem;\n  }\n\n  .p-tour-price {\n    font-size: 0.8rem;\n  }\n\n  .p-tour-price-text {\n    font-size: 0.7rem;\n  }\n\n  .p-tour-price span {\n    font-size: 0.7rem;\n  }\n\n  .view-details-button {\n    font-size: 0.7rem;\n    padding: 0.5rem;\n    border-radius: 5px;\n  }\n\n  .popular-tours-title {\n    padding: 0;\n    margin: 1rem 0;\n  }\n\n  .popular-tours-title h2 {\n    margin-bottom: 1rem;\n  }\n\n  /* banner */\n  .banner .icon {\n    font-size: 0.5rem;\n    width: 40px;\n    height: 40px;\n  }\n  .banner .text-section {\n    padding: 0;\n  }\n  .banner .text-section h2 {\n    font-size: 1.2rem;\n  }\n  .banner .book-now {\n    font-size: 0.8rem;\n    padding: 0.5rem 1rem;\n  }\n  .banner .text-section p {\n    font-size: 0.8rem;\n    display: flex;\n    flex-direction: row;\n  }\n  .banner .text-section p span {\n    margin-left: 0.5rem;\n  }\n  .reviews-section {\n    padding: 0.5rem;\n  }\n  .reviews-grid {\n    display: flex;\n    overflow-x: auto;\n    gap: 0rem;\n    padding: 0;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .review-text {\n    text-align: justify;\n  }\n\n  .read-more-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .review-author-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .stars {\n    justify-content: center;\n  }\n\n  .reviews-grid::-webkit-scrollbar {\n    display: none;\n  }\n  .review-card {\n    width: 90vw;\n    flex: 0 0 90vw;\n    scroll-snap-align: start;\n    padding: 0.5rem;\n    min-width: auto;\n    text-align: center;\n  }\n\n  .slider-dots {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 15px;\n    padding-bottom: 10px;\n    position: relative;\n    z-index: 2;\n  }\n\n  .dot {\n    width: 8px;\n    height: 8px;\n    border: 1px solid #e8c140;\n    border-radius: 50%;\n    display: block; /* Ensure dots are visible */\n  }\n\n  .dot.active {\n    background-color: #e8c140;\n  }\n\n  .view-all-button,\n  .view-all-activities,\n  .articles-view-all-button {\n    padding: 8px 24px;\n    font-size: 0.9rem;\n    margin-top: 1rem;\n  }\n\n  .view-all-container,\n  .articles-view-all-container {\n    margin-top: 1rem;\n    padding: 0 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
